import React from 'react';
import { createKeyboardShortcut } from 'utils/keyboardShortcuts';
import classes from './style.module.scss';
import AddIcon from 'assets/images/icons/JSX/Add';

export default ({
    onClick,
    title=""
}) => (
    <div
        onClick={onClick}
        className={classes.addBox}
        {...createKeyboardShortcut({ onKeyDown: onClick })}
    >
        <AddIcon /> <p>{title}</p>
    </div>
);